import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import Seo from "../components/Seo";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

import "./TermsPage.css";

const sections = [
    {
        icon: <DescriptionOutlinedIcon color="primary" />,
        title: "Назначение сервиса",
        paragraphs: [
            "Сервис предназначен для автоматизированной обработки документов, связанных с выплатами, банковскими платежными поручениями и внутренними учетными процессами организации.",
            "Сервис может использоваться для предварительного анализа PDF-документов, определения банка и проверки структуры документа, сверки банковских данных с данными учета и кадровой информацией, конвертации банковских документов в структурированные реестры, формирования итоговых таблиц и выгрузки результатов в Excel.",
        ],
    },
    {
        icon: <AccountCircleOutlinedIcon color="primary" />,
        title: "Доступ к сервису",
        paragraphs: [
            "Доступ к функционалу сайта предоставляется пользователю администрацией сайта.",
            "Самостоятельная регистрация на сайте не предусмотрена. Логин и пароль создаются администрацией сайта и передаются пользователю по указанным им контактным данным.",
        ],
        list: [
            "Не передавать доступ к своей учетной записи третьим лицам",
            "Обеспечивать сохранность логина и пароля",
            "Сообщать администрации о подозрении на несанкционированный доступ",
            "Использовать учетную запись только в рамках предоставленных прав",
        ],
    },
    {
        icon: <WorkspacePremiumOutlinedIcon color="primary" />,
        title: "Подписка и ограничения доступа",
        paragraphs: [
            "Доступ к отдельным функциям сайта может предоставляться только при наличии активной подписки.",
            "Часть функционала может быть недоступна без активной подписки или при нарушении условий использования сервиса.",
        ],
        list: [
            "Отсутствие активной подписки",
            "Окончание срока действия подписки",
            "Обработка документов, не относящихся к организациям пользователя",
            "Превышение технических ограничений сервиса",
            "Нарушение условий использования сайта",
        ],
    },
    {
        icon: <GavelOutlinedIcon color="primary" />,
        title: "Правила использования",
        paragraphs: [
            "Пользователь обязуется использовать сайт исключительно в законных целях.",
        ],
        list: [
            "Не нарушать законодательство Республики Казахстан",
            "Не загружать вредоносные файлы, вирусы и скрипты",
            "Не обходить ограничения подписки",
            "Не пытаться получить доступ к чужим учетным записям",
            "Не вмешиваться в работу сайта и серверов",
            "Не использовать автоматическую массовую загрузку файлов",
            "Не обрабатывать данные без законных оснований",
        ],
        accent: true,
    },
    {
        icon: <LockOutlinedIcon color="primary" />,
        title: "Обработка документов",
        paragraphs: [
            "Пользователь подтверждает, что имеет право загружать и обрабатывать документы, содержащие персональные данные, сведения о сотрудниках, банковские реквизиты и иную конфиденциальную информацию.",
            "Пользователь самостоятельно отвечает за достоверность, актуальность, полноту и оригинальность загружаемых документов.",
            "Сайт выполняет обработку документов автоматически и не гарантирует абсолютную точность результата в каждом конкретном случае.",
            "Пользователь обязан самостоятельно проверять результаты обработки, сверки, конвертации и выгрузки данных перед их дальнейшим использованием.",
        ],
    },
    {
        icon: <WarningAmberOutlinedIcon color="primary" />,
        title: "Ограничение ответственности",
        paragraphs: [
            "Сервис предоставляется по принципу «как есть».",
        ],
        list: [
            "Ошибки в исходных документах пользователя",
            "Некорректное содержимое PDF- и Excel-файлов",
            "Использование устаревших или поврежденных документов",
            "Невозможность обработки документов неизвестного формата",
            "Использование результатов без дополнительной проверки",
            "Временная недоступность сайта",
            "Убытки вследствие использования или невозможности использования сайта",
        ],
    },
    {
        icon: <VerifiedUserOutlinedIcon color="primary" />,
        title: "Интеллектуальная собственность",
        paragraphs: [
            "Все элементы сайта, включая программный код, интерфейс, структуру, дизайн, тексты, алгоритмы обработки и базы данных, являются объектами интеллектуальной собственности.",
            "Пользователю предоставляется ограниченное право использования сайта исключительно в рамках его функционального назначения.",
        ],
        list: [
            "Копировать программный код сайта",
            "Распространять материалы сайта",
            "Воспроизводить интерфейс и структуру сайта",
            "Создавать аналогичные сервисы",
            "Изменять или декомпилировать программную часть сайта",
        ],
    },
    {
        icon: <SettingsOutlinedIcon color="primary" />,
        title: "Технические ограничения",
        paragraphs: [
            "Сайт может устанавливать ограничения на количество файлов, размер файлов, количество запросов, скорость обработки и объем доступного функционала в зависимости от тарифа пользователя.",
            "Администрация сайта вправе изменять технические ограничения без предварительного уведомления пользователя.",
        ],
    },
    {
        icon: <DescriptionOutlinedIcon color="primary" />,
        title: "Изменение соглашения",
        paragraphs: [
            "Администрация сайта вправе изменять настоящее Пользовательское соглашение.",
            "Актуальная редакция Соглашения всегда публикуется на сайте.",
            "Продолжение использования сайта после публикации изменений означает согласие пользователя с новой редакцией Соглашения.",
        ],
    },
];

function TermsCard({ icon, title, paragraphs, list, accent = false }) {
    return (
        <div className={`terms-card ${accent ? "terms-card--accent" : ""}`}>
            <div className="terms-card__header">
                <div className="terms-card__icon">{icon}</div>
                <Typography className="terms-card__title">
                    {title}
                </Typography>
            </div>

            {paragraphs && paragraphs.length > 0 && (
                <div className="terms-card__content">
                    {paragraphs.map((text, index) => (
                        <Typography key={index} className="terms-card__text">
                            {text}
                        </Typography>
                    ))}
                </div>
            )}

            {list && list.length > 0 && (
                <div className="terms-card__content">
                    {list.map((item) => (
                        <div key={item} className="terms-list-item">
                            <div className="terms-list-item__dot" />
                            <Typography className="terms-card__text terms-card__text--list">
                                {item}
                            </Typography>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default function TermsPage() {
    return (
        <>
            <Seo
                title="Пользовательское соглашение – Qarzhy"
                description="Пользовательское соглашение сервиса Qarzhy. Условия использования сайта, порядок доступа к сервису, правила обработки документов, подписка, ограничения ответственности и права пользователя."
                keywords="пользовательское соглашение Qarzhy, условия использования сервиса, обработка документов, подписка, правила использования сайта"
                url="https://qarzhy.kz/terms"
            />

            <Box className="terms-page">
                <div className="terms-shell">
                    <section className="terms-hero">
                        <Chip
                            label="Условия использования сервиса"
                            color="primary"
                            className="terms-hero__chip"
                        />

                        <Typography variant="h1" className="terms-hero__title">
                            Пользовательское соглашение
                        </Typography>

                        <Typography className="terms-hero__subtitle">
                            Настоящее соглашение регулирует порядок использования сервиса Qarzhy,
                            условия доступа к функционалу, правила обработки документов, ограничения
                            ответственности и иные условия использования сайта.
                        </Typography>
                    </section>

                    <div className="terms-cards">
                        <TermsCard
                            icon={<DescriptionOutlinedIcon color="primary" />}
                            title="Общие положения"
                            paragraphs={[
                                "Настоящее Пользовательское соглашение регулирует порядок использования сервиса Qarzhy для автоматизированной обработки банковских платежных поручений, сверки с данными учета, кадровыми данными и конвертации банковских документов.",
                                "Используя сайт, пользователь подтверждает, что ознакомился с условиями настоящего Соглашения, понимает их и принимает в полном объеме.",
                                "Если пользователь не согласен с условиями настоящего Соглашения, он обязан прекратить использование сайта.",
                            ]}
                        />

                        {sections.map((section) => (
                            <TermsCard
                                key={section.title}
                                icon={section.icon}
                                title={section.title}
                                paragraphs={section.paragraphs}
                                list={section.list}
                                accent={section.accent}
                            />
                        ))}

                        <TermsCard
                            icon={<GavelOutlinedIcon color="primary" />}
                            title="Заключительные положения"
                            paragraphs={[
                                "Настоящее Соглашение регулируется законодательством Республики Казахстан.",
                                "Продолжение использования сайта означает полное и безоговорочное принятие пользователем условий настоящего Соглашения.",
                                "Если отдельные положения настоящего Соглашения будут признаны недействительными, остальные положения продолжают действовать.",
                                "Споры и разногласия подлежат досудебному урегулированию. При невозможности достижения соглашения спор подлежит рассмотрению в судебном порядке в соответствии с законодательством Республики Казахстан.",
                            ]}
                        />
                    </div>
                </div>
            </Box>
        </>
    );
}